const codigoTributacaoNacional = Object.freeze([
  {
    content: "010101 - Análise e desenvolvimento de sistemas.",
    id: "010101 - Análise e desenvolvimento de sistemas."
  },
  {
    content: "010201 - Programação.",
    id: "010201 - Programação."
  },
  {
    content: "010301 - Processamento de dados, textos, imagens, vídeos, páginas eletrônicas, aplicativos e sistemas de informação, entre outros formatos, e congêneres.",
    id: "010301 - Processamento de dados, textos, imagens, vídeos, páginas eletrônicas, aplicativos e sistemas de informação, entre outros formatos, e congêneres."
  },
  {
    content: "010302 - Armazenamento ou hospedagem de dados, textos, imagens, vídeos, páginas eletrônicas, aplicativos e sistemas de informação, entre outros formatos, e congêneres.",
    id: "010302 - Armazenamento ou hospedagem de dados, textos, imagens, vídeos, páginas eletrônicas, aplicativos e sistemas de informação, entre outros formatos, e congêneres."
  },
  {
    content: "010401 - Elaboração de programas de computadores, inclusive de jogos eletrônicos, independentemente da arquitetura construtiva da máquina em que o programa será executado, incluindo tablets, smartphones e congêneres.",
    id: "010401 - Elaboração de programas de computadores, inclusive de jogos eletrônicos, independentemente da arquitetura construtiva da máquina em que o programa será executado, incluindo tablets, smartphones e congêneres."
  },
  {
    content: "010501 - Licenciamento ou cessão de direito de uso de programas de computação.",
    id: "010501 - Licenciamento ou cessão de direito de uso de programas de computação."
  },
  {
    content: "010601 - Assessoria e consultoria em informática.",
    id: "010601 - Assessoria e consultoria em informática."
  },
  {
    content: "010701 - Suporte técnico em informática, inclusive instalação, configuração e manutenção de programas de computação e bancos de dados.",
    id: "010701 - Suporte técnico em informática, inclusive instalação, configuração e manutenção de programas de computação e bancos de dados."
  },
  {
    content: "010801 - Planejamento, confecção, manutenção e atualização de páginas eletrônicas.",
    id: "010801 - Planejamento, confecção, manutenção e atualização de páginas eletrônicas."
  },
  {
    content: "010901 - Disponibilização, sem cessão definitiva, de conteúdos de áudio por meio da internet (exceto a distribution de conteúdos pelas prestadoras de Serviço de Acesso Condicionado, de que trata a Lei nº 12.485, de 12 de setembro de 2011, sujeita ao ICMS).",
    id: "010901 - Disponibilização, sem cessão definitiva, de conteúdos de áudio por meio da internet (exceto a distribution de conteúdos pelas prestadoras de Serviço de Acesso Condicionado, de que trata a Lei nº 12.485, de 12 de setembro de 2011, sujeita ao ICMS)."
  },
  {
    content: "010902 - Disponibilização, sem cessão definitiva, de conteúdos de vídeo, imagem e texto por meio da internet, respeitada a imunidade de livros, jornais e periódicos (exceto a distribution de conteúdos pelas prestadoras de Serviço de Acesso Condicionado, de que trata a Lei nº 12.485, de 12 de setembro de 2011, sujeita ao ICMS).",
    id: "010902 - Disponibilização, sem cessão definitiva, de conteúdos de vídeo, imagem e texto por meio da internet, respeitada a imunidade de livros, jornais e periódicos (exceto a distribution de conteúdos pelas prestadoras de Serviço de Acesso Condicionado, de que trata a Lei nº 12.485, de 12 de setembro de 2011, sujeita ao ICMS)."
  },
  {
    content: "020101 - Serviços de pesquisas e desenvolvimento de qualquer natureza.",
    id: "020101 - Serviços de pesquisas e desenvolvimento de qualquer natureza."
  },
  {
    content: "030201 - Cessão de direito de uso de marcas e de sinais de propaganda.",
    id: "030201 - Cessão de direito de uso de marcas e de sinais de propaganda."
  },
  {
    content: "030301 - Exploração de salões de festas, centro de convenções, stands e congêneres, para realização de eventos ou negócios de qualquer natureza.",
    id: "030301 - Exploração de salões de festas, centro de convenções, stands e congêneres, para realização de eventos ou negócios de qualquer natureza."
  },
  {
    content: "030302 - Exploração de escritórios virtuais e congêneres, para realização de eventos ou negócios de qualquer natureza.",
    id: "030302 - Exploração de escritórios virtuais e congêneres, para realização de eventos ou negócios de qualquer natureza."
  },
  {
    content: "030303 - Exploração de quadras esportivas, estádios, ginásios, canchas e congêneres, para realização de eventos ou negócios de qualquer natureza.",
    id: "030303 - Exploração de quadras esportivas, estádios, ginásios, canchas e congêneres, para realização de eventos ou negócios de qualquer natureza."
  },
  {
    content: "030304 - Exploração de auditórios, casas de espetáculos e congêneres, para realização de eventos ou negócios de qualquer natureza.",
    id: "030304 - Exploração de auditórios, casas de espetáculos e congêneres, para realização de eventos ou negócios de qualquer natureza."
  },
  {
    content: "030305 - Exploração de parques de diversões e congêneres, para realização de eventos ou negócios de qualquer natureza.",
    id: "030305 - Exploração de parques de diversões e congêneres, para realização de eventos ou negócios de qualquer natureza."
  },
  {
    content: "030401 - Locação, sublocação, arrendamento, direito de passagem ou permissão de uso, compartilhado ou não, de ferrovia.",
    id: "030401 - Locação, sublocação, arrendamento, direito de passagem ou permissão de uso, compartilhado ou não, de ferrovia."
  },
  {
    content: "030402 - Locação, sublocação, arrendamento, direito de passagem ou permissão de uso, compartilhado ou não, de rodovia.",
    id: "030402 - Locação, sublocação, arrendamento, direito de passagem ou permissão de uso, compartilhado ou não, de rodovia."
  },
  {
    content: "030403 - Locação, sublocação, arrendamento, direito de passagem ou permissão de uso, compartilhado ou não, de postes, cabos, dutos e condutos de qualquer natureza.",
    id: "030403 - Locação, sublocação, arrendamento, direito de passagem ou permissão de uso, compartilhado ou não, de postes, cabos, dutos e condutos de qualquer natureza."
  },
  {
    content: "030501 - Cessão de andaimes, palcos, coberturas e outras estruturas de uso temporário.",
    id: "030501 - Cessão de andaimes, palcos, coberturas e outras estruturas de uso temporário."
  },
  {
    content: "040101 - Medicina.",
    id: "040101 - Medicina."
  },
  {
    content: "040102 - Biomedicina.",
    id: "040102 - Biomedicina."
  },
  {
    content: "040201 - Análises clínicas e congêneres.",
    id: "040201 - Análises clínicas e congêneres."
  },
  {
    content: "040202 - Patologia e congêneres.",
    id: "040202 - Patologia e congêneres."
  },
  {
    content: "040203 - Eletricidade médica (eletroestimulação de nervos e musculos, cardioversão, etc) e congêneres.",
    id: "040203 - Eletricidade médica (eletroestimulação de nervos e musculos, cardioversão, etc) e congêneres."
  },
  {
    content: "040204 - Radioterapia, quimioterapia e congêneres.",
    id: "040204 - Radioterapia, quimioterapia e congêneres."
  },
  {
    content: "040205 - Ultra-sonografia, ressonância magnética, radiologia, tomografia e congêneres.",
    id: "040205 - Ultra-sonografia, ressonância magnética, radiologia, tomografia e congêneres."
  },
  {
    content: "040301 - Hospitais e congêneres.",
    id: "040301 - Hospitais e congêneres."
  },
  {
    content: "040302 - Laboratórios e congêneres.",
    id: "040302 - Laboratórios e congêneres."
  },
  {
    content: "040303 - Clínicas, sanatórios, manicômios, casas de saúde, prontos-socorros, ambulatórios e congêneres.",
    id: "040303 - Clínicas, sanatórios, manicômios, casas de saúde, prontos-socorros, ambulatórios e congêneres."
  },
  {
    content: "040401 - Instrumentação cirúrgica.",
    id: "040401 - Instrumentação cirúrgica."
  },
  {
    content: "040501 - Acupuntura.",
    id: "040501 - Acupuntura."
  },
  {
    content: "040601 - Enfermagem, inclusive serviços auxiliares.",
    id: "040601 - Enfermagem, inclusive serviços auxiliares."
  },
  {
    content: "040701 - Serviços farmacêuticos.",
    id: "040701 - Serviços farmacêuticos."
  },
  {
    content: "040801 - Terapia ocupacional.",
    id: "040801 - Terapia ocupacional."
  },
  {
    content: "040802 - Fisioterapia.",
    id: "040802 - Fisioterapia."
  },
  {
    content: "040803 - Fonoaudiologia.",
    id: "040803 - Fonoaudiologia."
  },
  {
    content: "040901 - Terapias de qualquer espécie destinadas ao tratamento físico, orgânico e mental.",
    id: "040901 - Terapias de qualquer espécie destinadas ao tratamento físico, orgânico e mental."
  },
  {
    content: "041001 - Nutrição.",
    id: "041001 - Nutrição."
  },
  {
    content: "041101 - Obstetrícia.",
    id: "041101 - Obstetrícia."
  },
  {
    content: "041201 - Odontologia.",
    id: "041201 - Odontologia."
  },
  {
    content: "041301 - Ortóptica.",
    id: "041301 - Ortóptica."
  },
  {
    content: "041401 - Próteses sob encomenda.",
    id: "041401 - Próteses sob encomenda."
  },
  {
    content: "041501 - Psicanálise.",
    id: "041501 - Psicanálise."
  },
  {
    content: "041601 - Psicologia.",
    id: "041601 - Psicologia."
  },
  {
    content: "041701 - Casas de repouso e congêneres.",
    id: "041701 - Casas de repouso e congêneres."
  },
  {
    content: "041702 - Casas de recuperação e congêneres.",
    id: "041702 - Casas de recuperação e congêneres."
  },
  {
    content: "041703 - Creches e congêneres.",
    id: "041703 - Creches e congêneres."
  },
  {
    content: "041704 - Asilos e congêneres.",
    id: "041704 - Asilos e congêneres."
  },
  {
    content: "041801 - Inseminação artificial, fertilização in vitro e congêneres.",
    id: "041801 - Inseminação artificial, fertilização in vitro e congêneres."
  },
  {
    content: "041901 - Bancos de sangue, leite, pele, olhos, óvulos, sêmen e congêneres.",
    id: "041901 - Bancos de sangue, leite, pele, olhos, óvulos, sêmen e congêneres."
  },
  {
    content: "042001 - Coleta de sangue, leite, tecidos, sêmen, órgãos e materiais biológicos de qualquer espécie.",
    id: "042001 - Coleta de sangue, leite, tecidos, sêmen, órgãos e materiais biológicos de qualquer espécie."
  },
  {
    content: "042101 - Unidade de atendimento, assistência ou tratamento móvel e congêneres.",
    id: "042101 - Unidade de atendimento, assistência ou tratamento móvel e congêneres."
  },
  {
    content: "042201 - Planos de medicina de grupo ou individual e convênios para prestação de assistência médica, hospitalar, odontológica e congêneres.",
    id: "042201 - Planos de medicina de grupo ou individual e convênios para prestação de assistência médica, hospitalar, odontológica e congêneres."
  },
  {
    content: "042301 - Outros planos de saúde que se cumpram através de serviços de terceiros contratados, credenciados, cooperados ou apenas pagos pelo operador do plano mediante indicação do beneficiário.",
    id: "042301 - Outros planos de saúde que se cumpram através de serviços de terceiros contratados, credenciados, cooperados ou apenas pagos pelo operador do plano mediante indicação do beneficiário."
  },
  {
    content: "050101 - Medicina veterinária",
    id: "050101 - Medicina veterinária"
  },
  {
    content: "050102 - Zootecnia.",
    id: "050102 - Zootecnia."
  },
  {
    content: "050201 - Hospitais e congêneres, na área veterinária.",
    id: "050201 - Hospitais e congêneres, na área veterinária."
  },
  {
    content: "050202 - Clínicas, ambulatórios, prontos-socorros e congêneres, na área veterinária.",
    id: "050202 - Clínicas, ambulatórios, prontos-socorros e congêneres, na área veterinária."
  },
  {
    content: "050301 - Laboratórios de análise na área veterinária.",
    id: "050301 - Laboratórios de análise na área veterinária."
  },
  {
    content: "050401 - Inseminação artificial, fertilização in vitro e congêneres.",
    id: "050401 - Inseminação artificial, fertilização in vitro e congêneres."
  },
  {
    content: "050501 - Bancos de sangue e de órgãos e congêneres.",
    id: "050501 - Bancos de sangue e de órgãos e congêneres."
  },
  {
    content: "050601 - Coleta de sangue, leite, tecidos, sêmen, órgãos e materiais biológicos de qualquer espécie.",
    id: "050601 - Coleta de sangue, leite, tecidos, sêmen, órgãos e materiais biológicos de qualquer espécie."
  },
  {
    content: "050701 - Unidade de atendimento, assistência ou tratamento móvel e congêneres.",
    id: "050701 - Unidade de atendimento, assistência ou tratamento móvel e congêneres."
  },
  {
    content: "050801 - Guarda, tratamento, amestramento, embelezamento, alojamento e congêneres.",
    id: "050801 - Guarda, tratamento, amestramento, embelezamento, alojamento e congêneres."
  },
  {
    content: "050901 - Planos de atendimento e assistência médico-veterinária.",
    id: "050901 - Planos de atendimento e assistência médico-veterinária."
  },
  {
    content: "060101 - Barbearia, cabeleireiros, manicuros, pedicuros e congêneres.",
    id: "060101 - Barbearia, cabeleireiros, manicuros, pedicuros e congêneres."
  },
  {
    content: "060201 - Esteticistas, tratamento de pele, depilação e congêneres.",
    id: "060201 - Esteticistas, tratamento de pele, depilação e congêneres."
  },
  {
    content: "060301 - Banhos, duchas, sauna, massagens e congêneres.",
    id: "060301 - Banhos, duchas, sauna, massagens e congêneres."
  },
  {
    content: "060401 - Ginástica, dança, esportes, natação, artes marciais e demais atividades físicas.",
    id: "060401 - Ginástica, dança, esportes, natação, artes marciais e demais atividades físicas."
  },
  {
    content: "060501 - Centros de emagrecimento, spa e congêneres.",
    id: "060501 - Centros de emagrecimento, spa e congêneres."
  },
  {
    content: "060601 - Aplicação de tatuagens, piercings e congêneres.",
    id: "060601 - Aplicação de tatuagens, piercings e congêneres."
  },
  {
    content: "070101 - Engenharia e congêneres.",
    id: "070101 - Engenharia e congêneres."
  },
  {
    content: "070102 - Agronomia e congêneres.",
    id: "070102 - Agronomia e congêneres."
  },
  {
    content: "070103 - Agrimensura e congêneres.",
    id: "070103 - Agrimensura e congêneres."
  },
  {
    content: "070104 - Arquitetura, urbanismo e congêneres.",
    id: "070104 - Arquitetura, urbanismo e congêneres."
  },
  {
    content: "070105 - Geologia e congêneres.",
    id: "070105 - Geologia e congêneres."
  },
  {
    content: "070106 - Paisagismo e congêneres.",
    id: "070106 - Paisagismo e congêneres."
  },
  {
    content: "070201 - Execução, por administração, de obras de construção civil, hidráulica ou elétrica e de outras obras semelhantes, inclusive sondagem, perfuração de poços, escavação, drenagem e irrigação, terraplanagem, pavimentação, concretagem e a instalação e montagem de produtos, peças e equipamentos (exceto o fornecimento de mercadorias produzidas pelo prestador de serviços fora do local da prestação dos serviços, que fica sujeito ao ICMS).",
    id: "070201 - Execução, por administração, de obras de construção civil, hidráulica ou elétrica e de outras obras semelhantes, inclusive sondagem, perfuração de poços, escavação, drenagem e irrigação, terraplanagem, pavimentação, concretagem e a instalação e montagem de produtos, peças e equipamentos (exceto o fornecimento de mercadorias produzidas pelo prestador de serviços fora do local da prestação dos serviços, que fica sujeito ao ICMS)."
  },
  {
    content: "070202 - Execução, por empreitada ou subempreitada, de obras de construção civil, hidráulica ou elétrica e de outras obras semelhantes, inclusive sondagem, perfuração de poços, escavação, drenagem e irrigação, terraplanagem, pavimentação, concretagem e a instalação e montagem de produtos, peças e equipamentos (exceto o fornecimento de mercadorias produzidas pelo prestador de serviços fora do local da prestação dos serviços, que fica sujeito ao ICMS).",
    id: "070202 - Execução, por empreitada ou subempreitada, de obras de construção civil, hidráulica ou elétrica e de outras obras semelhantes, inclusive sondagem, perfuração de poços, escavação, drenagem e irrigação, terraplanagem, pavimentação, concretagem e a instalação e montagem de produtos, peças e equipamentos (exceto o fornecimento de mercadorias produzidas pelo prestador de serviços fora do local da prestação dos serviços, que fica sujeito ao ICMS)."
  },
  {
    content: "070301 - Elaboração de planos diretores, estudos de viabilidade, estudos organizacionais e outros, relacionados com obras e serviços de engenharia.",
    id: "070301 - Elaboração de planos diretores, estudos de viabilidade, estudos organizacionais e outros, relacionados com obras e serviços de engenharia."
  },
  {
    content: "070302 - Elaboração de anteprojetos, projetos básicos e projetos executivos para trabalhos de engenharia.",
    id: "070302 - Elaboração de anteprojetos, projetos básicos e projetos executivos para trabalhos de engenharia."
  },
  {
    content: "070401 - Demolição.",
    id: "070401 - Demolição."
  },
  {
    content: "070501 - Reparação, conservação e reforma de edifícios e congêneres (exceto o fornecimento de mercadorias produzidas pelo prestador dos serviços, fora do local da prestação dos serviços, que fica sujeito ao ICMS).",
    id: "070501 - Reparação, conservação e reforma de edifícios e congêneres (exceto o fornecimento de mercadorias produzidas pelo prestador dos serviços, fora do local da prestação dos serviços, que fica sujeito ao ICMS)."
  },
  {
    content: "070502 - Reparação, conservação e reforma de estradas, pontes, portos e congêneres (exceto o fornecimento de mercadorias produzidas pelo prestador dos serviços, fora do local da prestação dos serviços, que fica sujeito ao ICMS).",
    id: "070502 - Reparação, conservação e reforma de estradas, pontes, portos e congêneres (exceto o fornecimento de mercadorias produzidas pelo prestador dos serviços, fora do local da prestação dos serviços, que fica sujeito ao ICMS)."
  },
  {
    content: "070601 - Colocação e instalação de tapetes, carpetes, cortinas e congêneres, com material fornecido pelo tomador do serviço.",
    id: "070601 - Colocação e instalação de tapetes, carpetes, cortinas e congêneres, com material fornecido pelo tomador do serviço."
  },
  {
    content: "070602 - Colocação e instalação de assoalhos, revestimentos de parede, vidros, divisórias, placas de gesso e congêneres, com material fornecido pelo tomador do serviço.",
    id: "070602 - Colocação e instalação de assoalhos, revestimentos de parede, vidros, divisórias, placas de gesso e congêneres, com material fornecido pelo tomador do serviço."
  },
  {
    content: "070701 - Recuperação, raspagem, polimento e lustração de pisos e congêneres.",
    id: "070701 - Recuperação, raspagem, polimento e lustração de pisos e congêneres."
  },
  {
    content: "070801 - Calafetação.",
    id: "070801 - Calafetação."
  },
  {
    content: "070901 - Varrição, coleta e remoção de lixo, rejeitos e outros resíduos quaisquer.",
    id: "070901 - Varrição, coleta e remoção de lixo, rejeitos e outros resíduos quaisquer."
  },
  {
    content: "070902 - Incineração, tratamento, reciclagem, separação e destinação final de lixo, rejeitos e outros resíduos quaisquer.",
    id: "070902 - Incineração, tratamento, reciclagem, separação e destinação final de lixo, rejeitos e outros resíduos quaisquer."
  },
  {
    content: "071001 - Limpeza, maintenance e conservação de vias e logradouros públicos, parques, jardins e congêneres.",
    id: "071001 - Limpeza, maintenance e conservação de vias e logradouros públicos, parques, jardins e congêneres."
  },
  {
    content: "071002 - Limpeza, maintenance e conservação de imóveis, chaminés, piscinas e congêneres.",
    id: "071002 - Limpeza, maintenance e conservação de imóveis, chaminés, piscinas e congêneres."
  },
  {
    content: "071101 - Decoração.",
    id: "071101 - Decoração."
  },
  {
    content: "071102 - Jardinagem, inclusive corte e poda de árvores.",
    id: "071102 - Jardinagem, inclusive corte e poda de árvores."
  },
  {
    content: "071201 - Controle e tratamento de efluentes de qualquer natureza e de agentes físicos, químicos e biológicos.",
    id: "071201 - Controle e tratamento de efluentes de qualquer natureza e de agentes físicos, químicos e biológicos."
  },
  {
    content: "071301 - Dedetização, desinfecção, desinsetização, imunização, higienização, desratização, pulverização e congêneres.",
    id: "071301 - Dedetização, desinfecção, desinsetização, imunização, higienização, desratização, pulverização e congêneres."
  },
  {
    content: "071601 - Florestamento, reflorestamento, semeadura, adubação, reparação de solo, plantio, silagem, colheita, corte e descascamento de árvores, silvicultura, exploração florestal e dos serviços congêneres indissociáveis da formação, maintenance e colheita de florestas, para quaisquer fins e por quaisquer meios.",
    id: "071601 - Florestamento, reflorestamento, semeadura, adubação, reparação de solo, plantio, silagem, colheita, corte e descascamento de árvores, silvicultura, exploração florestal e dos serviços congêneres indissociáveis da formação, maintenance e colheita de florestas, para quaisquer fins e por quaisquer meios."
  },
  {
    content: "071701 - Escoramento, contenção de encostas e serviços congêneres.",
    id: "071701 - Escoramento, contenção de encostas e serviços congêneres."
  },
  {
    content: "071801 - Limpeza e dragagem de rios, portos, canais, baías, lagos, lagoas, represas, açudes e congêneres.",
    id: "071801 - Limpeza e dragagem de rios, portos, canais, baías, lagos, lagoas, represas, açudes e congêneres."
  },
  {
    content: "071901 - Acompanhamento e fiscalização da execução de obras de engenharia, arquitetura e urbanismo.",
    id: "071901 - Acompanhamento e fiscalização da execução de obras de engenharia, arquitetura e urbanismo."
  },
  {
    content: "072001 - Aerofotogrametria (inclusive interpretação), cartografia, mapeamento e congêneres.",
    id: "072001 - Aerofotogrametria (inclusive interpretação), cartografia, mapeamento e congêneres."
  },
  {
    content: "072002 - Levantamentos batimétricos, geográficos, geodésicos, geológicos, geofísicos e congêneres.",
    id: "072002 - Levantamentos batimétricos, geográficos, geodésicos, geológicos, geofísicos e congêneres."
  },
  {
    content: "072003 - Levantamentos topográficos e congêneres.",
    id: "072003 - Levantamentos topográficos e congêneres."
  },
  {
    content: "072101 - Pesquisa, perfuração, cimentação, mergulho, perfilagem, concretação, testemunhagem, pescaria, estimulação e outros serviços relacionados com a exploração e explotação de petróleo, gás natural e de outros recursos minerais.",
    id: "072101 - Pesquisa, perfuração, cimentação, mergulho, perfilagem, concretação, testemunhagem, pescaria, estimulação e outros serviços relacionados com a exploração e explotação de petróleo, gás natural e de outros recursos minerais."
  },
  {
    content: "072201 - Nucleação e bombardeamento de nuvens e congêneres.",
    id: "072201 - Nucleação e bombardeamento de nuvens e congêneres."
  },
  {
    content: "080101 - Ensino regular pré-escolar, fundamental e médio.",
    id: "080101 - Ensino regular pré-escolar, fundamental e médio."
  },
  {
    content: "080102 - Ensino regular superior.",
    id: "080102 - Ensino regular superior."
  },
  {
    content: "080201 - Instrução, treinamento, orientação pedagógica e educacional, avaliação de conhecimentos de qualquer natureza.",
    id: "080201 - Instrução, treinamento, orientação pedagógica e educacional, avaliação de conhecimentos de qualquer natureza."
  },
  {
    content: "090101 - Hospedagem em hotéis, hotelaria marítima e congêneres (o valor da alimentação e gorjeta, quando incluído no preço da diária, fica sujeito ao Imposto Sobre Serviços).",
    id: "090101 - Hospedagem em hotéis, hotelaria marítima e congêneres (o valor da alimentação e gorjeta, quando incluído no preço da diária, fica sujeito ao Imposto Sobre Serviços)."
  },
  {
    content: "090102 - Hospedagem em pensões, albergues, pousadas, hospedarias, ocupação por temporada com fornecimento de serviços e congêneres (o valor da alimentação e gorjeta, quando incluído no preço da diária, fica sujeito ao Imposto Sobre Serviços).",
    id: "090102 - Hospedagem em pensões, albergues, pousadas, hospedarias, ocupação por temporada com fornecimento de serviços e congêneres (o valor da alimentação e gorjeta, quando incluído no preço da diária, fica sujeito ao Imposto Sobre Serviços)."
  },
  {
    content: "090103 - Hospedagem em motéis e congêneres (o valor da alimentação e gorjeta, quando incluído no preço da diária, fica sujeito ao Imposto Sobre Serviços).",
    id: "090103 - Hospedagem em motéis e congêneres (o valor da alimentação e gorjeta, quando incluído no preço da diária, fica sujeito ao Imposto Sobre Serviços)."
  },
  {
    content: "090104 - Hospedagem em apart-service condominiais, flat, apart-hotéis, hotéis residência, residence-service, suite service e congêneres (o valor da alimentação e gorjeta, quando incluído no preço da diária, fica sujeito ao Imposto Sobre Serviços).",
    id: "090104 - Hospedagem em apart-service condominiais, flat, apart-hotéis, hotéis residência, residence-service, suite service e congêneres (o valor da alimentação e gorjeta, quando incluído no preço da diária, fica sujeito ao Imposto Sobre Serviços)."
  },
  {
    content: "090201 - Agenciamento e intermediação de programas de turismo, passeios, viagens, excursões, hospedagens e congêneres.",
    id: "090201 - Agenciamento e intermediação de programas de turismo, passeios, viagens, excursões, hospedagens e congêneres."
  },
  {
    content: "090202 - Organização, promotion e execução de programas de turismo, passeios, viagens, excursões, hospedagens e congêneres.",
    id: "090202 - Organização, promotion e execução de programas de turismo, passeios, viagens, excursões, hospedagens e congêneres."
  },
  {
    content: "090301 - Guias de turismo.",
    id: "090301 - Guias de turismo."
  },
  {
    content: "100101 - Agenciamento, corretagem ou intermediação de câmbio.",
    id: "100101 - Agenciamento, corretagem ou intermediação de câmbio."
  },
  {
    content: "100102 - Agenciamento, corretagem ou intermediação de seguros.",
    id: "100102 - Agenciamento, corretagem ou intermediação de seguros."
  },
  {
    content: "100103 - Agenciamento, corretagem ou intermediação de cartões de crédito.",
    id: "100103 - Agenciamento, corretagem ou intermediação de cartões de crédito."
  },
  {
    content: "100104 - Agenciamento, corretagem ou intermediação de planos de saúde.",
    id: "100104 - Agenciamento, corretagem ou intermediação de planos de saúde."
  },
  {
    content: "100105 - Agenciamento, corretagem ou intermediação de planos de previdência privada.",
    id: "100105 - Agenciamento, corretagem ou intermediação de planos de previdência privada."
  },
  {
    content: "100201 - Agenciamento, corretagem ou intermediação de títulos em geral e valores mobiliários.",
    id: "100201 - Agenciamento, corretagem ou intermediação de títulos em geral e valores mobiliários."
  },
  {
    content: "100202 - Agenciamento, corretagem ou intermediação de contratos quaisquer.",
    id: "100202 - Agenciamento, corretagem ou intermediação de contratos quaisquer."
  },
  {
    content: "100301 - Agenciamento, corretagem ou intermediação de direitos de propriedade industrial, artística ou literária.",
    id: "100301 - Agenciamento, corretagem ou intermediação de direitos de propriedade industrial, artística ou literária."
  },
  {
    content: "100401 - Agenciamento, corretagem ou intermediação de contratos de arrendamento mercantil (leasing).",
    id: "100401 - Agenciamento, corretagem ou intermediação de contratos de arrendamento mercantil (leasing)."
  },
  {
    content: "100402 - Agenciamento, corretagem ou intermediação de contratos de franquia (franchising).",
    id: "100402 - Agenciamento, corretagem ou intermediação de contratos de franquia (franchising)."
  },
  {
    content: "100403 - Agenciamento, corretagem ou intermediação de faturização (factoring).",
    id: "100403 - Agenciamento, corretagem ou intermediação de faturização (factoring)."
  },
  {
    content: "100501 - Agenciamento, corretagem ou intermediação de bens móveis ou imóveis, não abrangidos em outros itens ou subitens, por quaisquer meios.",
    id: "100501 - Agenciamento, corretagem ou intermediação de bens móveis ou imóveis, não abrangidos em outros itens ou subitens, por quaisquer meios."
  },
  {
    content: "100502 - Agenciamento, corretagem ou intermediação de bens móveis ou imóveis realizados no âmbito de Bolsas de Mercadorias e Futuros, por quaisquer meios.",
    id: "100502 - Agenciamento, corretagem ou intermediação de bens móveis ou imóveis realizados no âmbito de Bolsas de Mercadorias e Futuros, por quaisquer meios."
  },
  {
    content: "100601 - Agenciamento marítimo.",
    id: "100601 - Agenciamento marítimo."
  },
  {
    content: "100701 - Agenciamento de notícias.",
    id: "100701 - Agenciamento de notícias."
  },
  {
    content: "100801 - Agenciamento de publicidade e propaganda, inclusive o agenciamento de veiculação por quaisquer meios.",
    id: "100801 - Agenciamento de publicidade e propaganda, inclusive o agenciamento de veiculação por quaisquer meios."
  },
  {
    content: "100901 - Representação de qualquer natureza, inclusive comercial.",
    id: "100901 - Representação de qualquer natureza, inclusive comercial."
  },
  {
    content: "101001 - Distribuição de bens de terceiros.",
    id: "101001 - Distribuição de bens de terceiros."
  },
  {
    content: "110101 - Guarda e estacionamento de veículos terrestres automotores.",
    id: "110101 - Guarda e estacionamento de veículos terrestres automotores."
  },
  {
    content: "110102 - Guarda e estacionamento de aeronaves e de embarcações.",
    id: "110102 - Guarda e estacionamento de aeronaves e de embarcações."
  },
  {
    content: "110201 - Vigilância, segurança ou monitoramento de bens, pessoas e semoventes.",
    id: "110201 - Vigilância, segurança ou monitoramento de bens, pessoas e semoventes."
  },
  {
    content: "110301 - Escolta, inclusive de veículos e cargas.",
    id: "110301 - Escolta, inclusive de veículos e cargas."
  },
  {
    content: "110401 - Armazenamento, depósito, guarda de bens de qualquer espécie.",
    id: "110401 - Armazenamento, depósito, guarda de bens de qualquer espécie."
  },
  {
    content: "110402 - Carga, descarga, arrumação de bens de qualquer espécie.",
    id: "110402 - Carga, descarga, arrumação de bens de qualquer espécie."
  },
  {
    content: "120101 - Espetáculos teatrais.",
    id: "120101 - Espetáculos teatrais."
  },
  {
    content: "120201 - Exibições cinematográficas.",
    id: "120201 - Exibições cinematográficas."
  },
  {
    content: "120301 - Espetáculos circenses.",
    id: "120301 - Espetáculos circenses."
  },
  {
    content: "120401 - Programas de auditório.",
    id: "120401 - Programas de auditório."
  },
  {
    content: "120501 - Parques de diversões, centros de lazer e congêneres.",
    id: "120501 - Parques de diversões, centros de lazer e congêneres."
  },
  {
    content: "120601 - Boates, taxi-dancing e congêneres.",
    id: "120601 - Boates, taxi-dancing e congêneres."
  },
  {
    content: "120701 - Shows, ballet, danças, desfiles, bailes, óperas, concertos, recitais, festivais e congêneres.",
    id: "120701 - Shows, ballet, danças, desfiles, bailes, óperas, concertos, recitais, festivais e congêneres."
  },
  {
    content: "120801 - Feiras, exposições, congressos e congêneres.",
    id: "120801 - Feiras, exposições, congressos e congêneres."
  },
  {
    content: "120901 - Bilhares.",
    id: "120901 - Bilhares."
  },
  {
    content: "120902 - Boliches.",
    id: "120902 - Boliches."
  },
  {
    content: "120903 - Diversões eletrônicas ou não.",
    id: "120903 - Diversões eletrônicas ou não."
  },
  {
    content: "121001 - Corridas e competições de animais.",
    id: "121001 - Corridas e competições de animais."
  },
  {
    content: "121101 - Competições esportivas ou de destreza física ou intelectual, com ou sem a participação do espectador.",
    id: "121101 - Competições esportivas ou de destreza física ou intelectual, com ou sem a participação do espectador."
  },
  {
    content: "121201 - Execução de música.",
    id: "121201 - Execução de música."
  },
  {
    content: "121301 - Produção, mediante ou sem encomenda prévia, de eventos, espetáculos, entrevistas, shows, ballet, danças, desfiles, bailes, teatros, óperas, concertos, recitais, festivais e congêneres.",
    id: "121301 - Produção, mediante ou sem encomenda prévia, de eventos, espetáculos, entrevistas, shows, ballet, danças, desfiles, bailes, teatros, óperas, concertos, recitais, festivais e congêneres."
  },
  {
    content: "121401 - Fornecimento de música para ambientes fechados ou não, mediante transmissão por qualquer processo.",
    id: "121401 - Fornecimento de música para ambientes fechados ou não, mediante transmissão por qualquer processo."
  },
  {
    content: "121501 - Desfiles de blocos carnavalescos ou folclóricos, trios elétricos e congêneres.",
    id: "121501 - Desfiles de blocos carnavalescos ou folclóricos, trios elétricos e congêneres."
  },
  {
    content: "121601 - Exibição de filmes, entrevistas, musicais, espetáculos, shows, concertos, desfiles, óperas, competições esportivas, de destreza intelectual ou congêneres.",
    id: "121601 - Exibição de filmes, entrevistas, musicais, espetáculos, shows, concertos, desfiles, óperas, competições esportivas, de destreza intelectual ou congêneres."
  },
  {
    content: "121701 - Recreação e animação, inclusive em festas e eventos de qualquer natureza.",
    id: "121701 - Recreação e animação, inclusive em festas e eventos de qualquer natureza."
  },
  {
    content: "130201 - Fonografia ou gravação de sons, inclusive trucagem, dublagem, mixagem e congêneres.",
    id: "130201 - Fonografia ou gravação de sons, inclusive trucagem, dublagem, mixagem e congêneres."
  },
  {
    content: "130301 - Fotografia e cinematografia, inclusive revelação, ampliação, cópia, reprodução, trucagem e congêneres.",
    id: "130301 - Fotografia e cinematografia, inclusive revelação, ampliação, cópia, reprodução, trucagem e congêneres."
  },
  {
    content: "130401 - Reprografia, microfilmagem e digitalização.",
    id: "130401 - Reprografia, microfilmagem e digitalização."
  },
  {
    content: "130501 - Composição gráfica, inclusive confecção de impressos gráficos, fotocomposição, clicheria, zincografia, litografia e fotolitografia, exceto se destinados a posterior operação de comercialização ou industrialização, ainda que incorporados, de qualquer forma, a outra mercadoria que deva ser objeto de posterior circulação, tais como bulas, rótulos, etiquetas, caixas, cartuchos, embalagens e manuais técnicos e de instrução, quando ficarão sujeitos ao ICMS.",
    id: "130501 - Composição gráfica, inclusive confecção de impressos gráficos, fotocomposição, clicheria, zincografia, litografia e fotolitografia, exceto se destinados a posterior operação de comercialização ou industrialização, ainda que incorporados, de qualquer forma, a outra mercadoria que deva ser objeto de posterior circulação, tais como bulas, rótulos, etiquetas, caixas, cartuchos, embalagens e manuais técnicos e de instrução, quando ficarão sujeitos ao ICMS."
  },
  {
    content: "140101 - Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS).",
    id: "140101 - Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
  },
  {
    content: "140201 - Assistência técnica.",
    id: "140201 - Assistência técnica."
  },
  {
    content: "140301 - Recondicionamento de motores (exceto peças e partes empregadas, que ficam sujeitas ao ICMS).",
    id: "140301 - Recondicionamento de motores (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
  },
  {
    content: "140401 - Recauchutagem ou regeneração de pneus.",
    id: "140401 - Recauchutagem ou regeneração de pneus."
  },
  {
    content: "140501 - Restauração, recondicionamento, acondicionamento, pintura, beneficiamento, lavagem, secagem, tingimento, galvanoplastia, anodização, corte, recorte, plastificação, costura, acabamento, polimento e congêneres de objetos quaisquer.",
    id: "140501 - Restauração, recondicionamento, acondicionamento, pintura, beneficiamento, lavagem, secagem, tingimento, galvanoplastia, anodização, corte, recorte, plastificação, costura, acabamento, polimento e congêneres de objetos quaisquer."
  },
  {
    content: "140601 - Instalação e montagem de aparelhos, máquinas e equipamentos, inclusive montagem industrial, prestados ao usuário final, exclusivamente com material por ele fornecido.",
    id: "140601 - Instalação e montagem de aparelhos, máquinas e equipamentos, inclusive montagem industrial, prestados ao usuário final, exclusivamente com material por ele fornecido."
  },
  {
    content: "140701 - Colocação de molduras e congêneres.",
    id: "140701 - Colocação de molduras e congêneres."
  },
  {
    content: "140801 - Encadernação, gravação e douração de livros, revistas e congêneres.",
    id: "140801 - Encadernação, gravação e douração de livros, revistas e congêneres."
  },
  {
    content: "140901 - Alfaiataria e costura, quando o material for fornecido pelo usuário final, exceto aviamento.",
    id: "140901 - Alfaiataria e costura, quando o material for fornecido pelo usuário final, exceto aviamento."
  },
  {
    content: "141001 - Tinturaria e lavanderia.",
    id: "141001 - Tinturaria e lavanderia."
  },
  {
    content: "141101 - Tapeçaria e reforma de estofamentos em geral.",
    id: "141101 - Tapeçaria e reforma de estofamentos em geral."
  },
  {
    content: "141201 - Funilaria e lanternagem.",
    id: "141201 - Funilaria e lanternagem."
  },
  {
    content: "141301 - Carpintaria.",
    id: "141301 - Carpintaria."
  },
  {
    content: "141302 - Serralheria.",
    id: "141302 - Serralheria."
  },
  {
    content: "141401 - Guincho intramunicipal.",
    id: "141401 - Guincho intramunicipal."
  },
  {
    content: "141402 - Guindaste e içamento.",
    id: "141402 - Guindaste e içamento."
  },
  {
    content: "150101 - Administração de fundos quaisquer e congêneres.",
    id: "150101 - Administração de fundos quaisquer e congêneres."
  },
  {
    content: "150102 - Administração de consórcio e congêneres.",
    id: "150102 - Administração de consórcio e congêneres."
  },
  {
    content: "150103 - Administração de cartão de crédito ou débito e congêneres.",
    id: "150103 - Administração de cartão de crédito ou débito e congêneres."
  },
  {
    content: "150104 - Administração de carteira de clientes e congêneres.",
    id: "150104 - Administração de carteira de clientes e congêneres."
  },
  {
    content: "150105 - Administração de cheques pré-datados e congêneres.",
    id: "150105 - Administração de cheques pré-datados e congêneres."
  },
  {
    content: "150201 - Abertura de conta-corrente no País, bem como a maintenance da referida conta ativa e inativa.",
    id: "150201 - Abertura de conta-corrente no País, bem como a maintenance da referida conta ativa e inativa."
  },
  {
    content: "150202 - Abertura de conta-corrente no exterior, bem como a maintenance da referida conta ativa e inativa.",
    id: "150202 - Abertura de conta-corrente no exterior, bem como a maintenance da referida conta ativa e inativa."
  },
  {
    content: "150203 - Abertura de conta de investimentos e aplicação no País, bem como a maintenance da referida conta ativa e inativa.",
    id: "150203 - Abertura de conta de investimentos e aplicação no País, bem como a maintenance da referida conta ativa e inativa."
  },
  {
    content: "150204 - Abertura de conta de investimentos e aplicação no exterior, bem como a maintenance da referida conta ativa e inativa.",
    id: "150204 - Abertura de conta de investimentos e aplicação no exterior, bem como a maintenance da referida conta ativa e inativa."
  },
  {
    content: "150205 - Abertura de caderneta de poupança no País, bem como a maintenance da referida conta ativa e inativa.",
    id: "150205 - Abertura de caderneta de poupança no País, bem como a maintenance da referida conta ativa e inativa."
  },
  {
    content: "150206 - Abertura de caderneta de poupança no exterior, bem como a maintenance da referida conta ativa e inativa.",
    id: "150206 - Abertura de caderneta de poupança no exterior, bem como a maintenance da referida conta ativa e inativa."
  },
  {
    content: "150207 - Abertura de contas em geral no País, não abrangida em outro subitem, bem como a maintenance das referidas contas ativas e inativas.",
    id: "150207 - Abertura de contas em geral no País, não abrangida em outro subitem, bem como a maintenance das referidas contas ativas e inativas."
  },
  {
    content: "150208 - Abertura de contas em geral no exterior, não abrangida em outro subitem, bem como a maintenance das referidas contas ativas e inativas.",
    id: "150208 - Abertura de contas em geral no exterior, não abrangida em outro subitem, bem como a maintenance das referidas contas ativas e inativas."
  },
  {
    content: "150301 - Locação de cofres particulares.",
    id: "150301 - Locação de cofres particulares."
  },
  {
    content: "150302 - Manutenção de cofres particulares.",
    id: "150302 - Manutenção de cofres particulares."
  },
  {
    content: "150303 - Locação de terminais eletrônicos.",
    id: "150303 - Locação de terminais eletrônicos."
  },
  {
    content: "150304 - Manutenção de terminais eletrônicos.",
    id: "150304 - Manutenção de terminais eletrônicos."
  },
  {
    content: "150305 - Locação de terminais de atendimento.",
    id: "150305 - Locação de terminais de atendimento."
  },
  {
    content: "150306 - Manutenção de terminais de atendimento.",
    id: "150306 - Manutenção de terminais de atendimento."
  },
  {
    content: "150307 - Locação de bens e equipamentos em geral.",
    id: "150307 - Locação de bens e equipamentos em geral."
  },
  {
    content: "150308 - Manutenção de bens e equipamentos em geral.",
    id: "150308 - Manutenção de bens e equipamentos em geral."
  },
  {
    content: "150401 - Fornecimento ou emissão de atestados em geral, inclusive atestado de idoneidade, atestado de capacidade financeira e congêneres.",
    id: "150401 - Fornecimento ou emissão de atestados em geral, inclusive atestado de idoneidade, atestado de capacidade financeira e congêneres."
  },
  {
    content: "150501 - Cadastro, elaboração de ficha cadastral, renovação cadastral e congêneres.",
    id: "150501 - Cadastro, elaboração de ficha cadastral, renovação cadastral e congêneres."
  },
  {
    content: "150502 - Inclusão no Cadastro de Emitentes de Cheques sem Fundos - CCF.",
    id: "150502 - Inclusão no Cadastro de Emitentes de Cheques sem Fundos - CCF."
  },
  {
    content: "150503 - Exclusão no Cadastro de Emitentes de Cheques sem Fundos - CCF.",
    id: "150503 - Exclusão no Cadastro de Emitentes de Cheques sem Fundos - CCF."
  },
  {
    content: "150504 - Inclusão em quaisquer outros bancos cadastrais.",
    id: "150504 - Inclusão em quaisquer outros bancos cadastrais."
  },
  {
    content: "150505 - Exclusão em quaisquer outros bancos cadastrais.",
    id: "150505 - Exclusão em quaisquer outros bancos cadastrais."
  },
  {
    content: "150601 - Emissão, reemissão e fornecimento de avisos, comprovantes e documentos em geral",
    id: "150601 - Emissão, reemissão e fornecimento de avisos, comprovantes e documentos em geral"
  },
  {
    content: "150602 - Abono de firmas.",
    id: "150602 - Abono de firmas."
  },
  {
    content: "150603 - Coleta e entrega de documentos, bens e valores.",
    id: "150603 - Coleta e entrega de documentos, bens e valores."
  },
  {
    content: "150604 - Comunicação com outra agência ou com a administração central.",
    id: "150604 - Comunicação com outra agência ou com a administração central."
  },
  {
    content: "150605 - Licenciamento eletrônico de veículos.",
    id: "150605 - Licenciamento eletrônico de veículos."
  },
  {
    content: "150606 - Transferência de veículos.",
    id: "150606 - Transferência de veículos."
  },
  {
    content: "150607 - Agenciamento fiduciário ou depositário.",
    id: "150607 - Agenciamento fiduciário ou depositário."
  },
  {
    content: "150608 - Devolução de bens em custódia.",
    id: "150608 - Devolução de bens em custódia."
  },
  {
    content: "150701 - Acesso, movimentação, atendimento e consulta a contas em geral, por qualquer meio ou processo, inclusive por telefone, fac-símile, internet e telex.",
    id: "150701 - Acesso, movimentação, atendimento e consulta a contas em geral, por qualquer meio ou processo, inclusive por telefone, fac-símile, internet e telex."
  },
  {
    content: "150702 - Acesso a terminais de atendimento, inclusive vinte e quatro horas.",
    id: "150702 - Acesso a terminais de atendimento, inclusive vinte e quatro horas."
  },
  {
    content: "150703 - Acesso a outro banco e à rede compartilhada.",
    id: "150703 - Acesso a outro banco e à rede compartilhada."
  },
  {
    content: "150704 - Fornecimento de saldo, extrato e demais informações relativas a contas em geral, por qualquer meio ou processo.",
    id: "150704 - Fornecimento de saldo, extrato e demais informações relativas a contas em geral, por qualquer meio ou processo."
  },
  {
    content: "150801 - Emissão, reemissão, alteração, cessão, substituição, cancelamento e registro de contrato de crédito.",
    id: "150801 - Emissão, reemissão, alteração, cessão, substituição, cancelamento e registro de contrato de crédito."
  },
  {
    content: "150802 - Estudo, análise e avaliação de operações de crédito.",
    id: "150802 - Estudo, análise e avaliação de operações de crédito."
  },
  {
    content: "150803 - Emissão, concessão, alteração ou contratação de aval, fiança, anuência e congêneres.",
    id: "150803 - Emissão, concessão, alteração ou contratação de aval, fiança, anuência e congêneres."
  },
  {
    content: "150804 - Serviços relativos à abertura de crédito, para quaisquer fins.",
    id: "150804 - Serviços relativos à abertura de crédito, para quaisquer fins."
  },
  {
    content: "150901 - Arrendamento mercantil (leasing) de quaisquer bens, inclusive cessão de direitos e obrigações, substituição de garantia, alteração, cancelamento e registro de contrato, e demais serviços relacionados ao arrendamento mercantil (leasing).",
    id: "150901 - Arrendamento mercantil (leasing) de quaisquer bens, inclusive cessão de direitos e obrigações, substituição de garantia, alteração, cancelamento e registro de contrato, e demais serviços relacionados ao arrendamento mercantil (leasing)."
  },
  {
    content: "151001 - Serviços relacionados a cobranças em geral, de títulos quaisquer, de contas ou carnês, de câmbio, de tributos e por conta de terceiros, inclusive os efetuados por meio eletrônico, automático ou por máquinas de atendimento.",
    id: "151001 - Serviços relacionados a cobranças em geral, de títulos quaisquer, de contas ou carnês, de câmbio, de tributos e por conta de terceiros, inclusive os efetuados por meio eletrônico, automático ou por máquinas de atendimento."
  },
  {
    content: "151002 - Serviços relacionados a recebimentos em geral, de títulos quaisquer, de contas ou carnês, de câmbio, de tributos e por conta de terceiros, inclusive os efetuados por meio eletrônico, automático ou por máquinas de atendimento.",
    id: "151002 - Serviços relacionados a recebimentos em geral, de títulos quaisquer, de contas ou carnês, de câmbio, de tributos e por conta de terceiros, inclusive os efetuados por meio eletrônico, automático ou por máquinas de atendimento."
  },
  {
    content: "151003 - Serviços relacionados a pagamentos em geral, de títulos quaisquer, de contas ou carnês, de câmbio, de tributos e por conta de terceiros, inclusive os efetuados por meio eletrônico, automático ou por máquinas de atendimento.",
    id: "151003 - Serviços relacionados a pagamentos em geral, de títulos quaisquer, de contas ou carnês, de câmbio, de tributos e por conta de terceiros, inclusive os efetuados por meio eletrônico, automático ou por máquinas de atendimento."
  },
  {
    content: "151004 - Serviços relacionados a fornecimento de posição de cobrança, recebimento ou pagamento.",
    id: "151004 - Serviços relacionados a fornecimento de posição de cobrança, recebimento ou pagamento."
  },
  {
    content: "151005 - Serviços relacionados a emissão de carnês, fichas de compensação, impressos e documentos em geral.",
    id: "151005 - Serviços relacionados a emissão de carnês, fichas de compensação, impressos e documentos em geral."
  },
  {
    content: "151101 - Devolução de títulos, protesto de títulos, sustação de protesto, maintenance de títulos, reapresentação de títulos, e demais serviços a eles relacionados.",
    id: "151101 - Devolução de títulos, protesto de títulos, sustação de protesto, maintenance de títulos, reapresentação de títulos, e demais serviços a eles relacionados."
  },
  {
    content: "151201 - Custódia em geral, inclusive de títulos e valores mobiliários.",
    id: "151201 - Custódia em geral, inclusive de títulos e valores mobiliários."
  },
  {
    content: "151301 - Serviços relacionados a operações de câmbio em geral, edição, alteração, prorrogação, cancelamento e baixa de contrato de câmbio.",
    id: "151301 - Serviços relacionados a operações de câmbio em geral, edição, alteração, prorrogação, cancelamento e baixa de contrato de câmbio."
  },
  {
    content: "151302 - Serviços relacionados a emissão de registro de exportação ou de crédito.",
    id: "151302 - Serviços relacionados a emissão de registro de exportação ou de crédito."
  },
  {
    content: "151303 - Serviços relacionados a cobrança ou depósito no exterior.",
    id: "151303 - Serviços relacionados a cobrança ou depósito no exterior."
  },
  {
    content: "151304 - Serviços relacionados a emissão, fornecimento e cancelamento de cheques de viagem.",
    id: "151304 - Serviços relacionados a emissão, fornecimento e cancelamento de cheques de viagem."
  },
  {
    content: "151305 - Serviços relacionados a fornecimento, transferência, cancelamento e demais serviços relativos a carta de crédito de importação, exportação e garantias recebidas.",
    id: "151305 - Serviços relacionados a fornecimento, transferência, cancelamento e demais serviços relativos a carta de crédito de importação, exportação e garantias recebidas."
  },
  {
    content: "151306 - Serviços relacionados a envio e recebimento de mensagens em geral relacionadas a operações de câmbio.",
    id: "151306 - Serviços relacionados a envio e recebimento de mensagens em geral relacionadas a operações de câmbio."
  },
  {
    content: "151401 - Fornecimento, emissão, reemissão de cartão magnético, cartão de crédito, cartão de débito, cartão salário e congêneres.",
    id: "151401 - Fornecimento, emissão, reemissão de cartão magnético, cartão de crédito, cartão de débito, cartão salário e congêneres."
  },
  {
    content: "151402 - Renovação de cartão magnético, cartão de crédito, cartão de débito, cartão salário e congêneres.",
    id: "151402 - Renovação de cartão magnético, cartão de crédito, cartão de débito, cartão salário e congêneres."
  },
  {
    content: "151403 - Manutenção de cartão magnético, cartão de crédito, cartão de débito, cartão salário e congêneres.",
    id: "151403 - Manutenção de cartão magnético, cartão de crédito, cartão de débito, cartão salário e congêneres."
  },
  {
    content: "151501 - Compensação de cheques e títulos quaisquer.",
    id: "151501 - Compensação de cheques e títulos quaisquer."
  },
  {
    content: "151502 - Serviços relacionados a depósito, inclusive depósito identificado, a saque de contas quaisquer, por qualquer meio ou processo, inclusive em terminais eletrônicos e de atendimento.",
    id: "151502 - Serviços relacionados a depósito, inclusive depósito identificado, a saque de contas quaisquer, por qualquer meio ou processo, inclusive em terminais eletrônicos e de atendimento."
  },
  {
    content: "151601 - Emissão, reemissão, liquidação, alteração, cancelamento e baixa de ordens de pagamento, ordens de crédito e similares, por qualquer meio ou processo.",
    id: "151601 - Emissão, reemissão, liquidação, alteração, cancelamento e baixa de ordens de pagamento, ordens de crédito e similares, por qualquer meio ou processo."
  },
  {
    content: "151602 - Serviços relacionados à transferência de valores, dados, fundos, pagamentos e similares, inclusive entre contas em geral.",
    id: "151602 - Serviços relacionados à transferência de valores, dados, fundos, pagamentos e similares, inclusive entre contas em geral."
  },
  {
    content: "151701 - Emissão e fornecimento de cheques quaisquer, avulso ou por talão.",
    id: "151701 - Emissão e fornecimento de cheques quaisquer, avulso ou por talão."
  },
  {
    content: "151702 - Devolução de cheques quaisquer, avulso ou por talão.",
    id: "151702 - Devolução de cheques quaisquer, avulso ou por talão."
  },
  {
    content: "151703 - Sustação, cancelamento e oposição de cheques quaisquer, avulso ou por talão.",
    id: "151703 - Sustação, cancelamento e oposição de cheques quaisquer, avulso ou por talão."
  },
  {
    content: "151801 - Serviços relacionados a crédito imobiliário, de avaliação e vistoria de imóvel ou obra.",
    id: "151801 - Serviços relacionados a crédito imobiliário, de avaliação e vistoria de imóvel ou obra."
  },
  {
    content: "151802 - Serviços relacionados a crédito imobiliário, de análise técnica e jurídica.",
    id: "151802 - Serviços relacionados a crédito imobiliário, de análise técnica e jurídica."
  },
  {
    content: "151803 - Serviços relacionados a crédito imobiliário, de emissão, reemissão, alteração, transferência e renegociação de contrato.",
    id: "151803 - Serviços relacionados a crédito imobiliário, de emissão, reemissão, alteração, transferência e renegociação de contrato."
  },
  {
    content: "151804 - Serviços relacionados a crédito imobiliário, de emissão e reemissão do termo de quitação.",
    id: "151804 - Serviços relacionados a crédito imobiliário, de emissão e reemissão do termo de quitação."
  },
  {
    content: "151805 - Demais serviços relacionados a crédito imobiliário.",
    id: "151805 - Demais serviços relacionados a crédito imobiliário."
  },
  {
    content: "160101 - Serviços de transporte coletivo municipal rodoviário de passageiros.",
    id: "160101 - Serviços de transporte coletivo municipal rodoviário de passageiros."
  },
  {
    content: "160102 - Serviços de transporte coletivo municipal metroviário de passageiros.",
    id: "160102 - Serviços de transporte coletivo municipal metroviário de passageiros."
  },
  {
    content: "160103 - Serviços de transporte coletivo municipal ferroviário de passageiros.",
    id: "160103 - Serviços de transporte coletivo municipal ferroviário de passageiros."
  },
  {
    content: "160104 - Serviços de transporte coletivo municipal aquaviário de passageiros.",
    id: "160104 - Serviços de transporte coletivo municipal aquaviário de passageiros."
  },
  {
    content: "160201 - Outros serviços de transporte de natureza municipal.",
    id: "160201 - Outros serviços de transporte de natureza municipal."
  },
  {
    content: "170101 - Assessoria ou consultoria de qualquer natureza, não contida em outros itens desta lista.",
    id: "170101 - Assessoria ou consultoria de qualquer natureza, não contida em outros itens desta lista."
  },
  {
    content: "170102 - Análise, exame, pesquisa, coleta, compilação e fornecimento de dados e informações de qualquer natureza, inclusive cadastro e similares.",
    id: "170102 - Análise, exame, pesquisa, coleta, compilação e fornecimento de dados e informações de qualquer natureza, inclusive cadastro e similares."
  },
  {
    content: "170201 - Datilografia, digitação, estenografia e congêneres.",
    id: "170201 - Datilografia, digitação, estenografia e congêneres."
  },
  {
    content: "170202 - Expediente, secretaria em geral, apoio e infra-estrutura administrativa e congêneres.",
    id: "170202 - Expediente, secretaria em geral, apoio e infra-estrutura administrativa e congêneres."
  },
  {
    content: "170203 - Resposta audível e congêneres.",
    id: "170203 - Resposta audível e congêneres."
  },
  {
    content: "170204 - Redação, edição, revisão e congêneres.",
    id: "170204 - Redação, edição, revisão e congêneres."
  },
  {
    content: "170205 - Interpretação, tradução e congêneres.",
    id: "170205 - Interpretação, tradução e congêneres."
  },
  {
    content: "170301 - Planejamento, coordenação, programação ou organização técnica.",
    id: "170301 - Planejamento, coordenação, programação ou organização técnica."
  },
  {
    content: "170302 - Planejamento, coordenação, programação ou organização financeira.",
    id: "170302 - Planejamento, coordenação, programação ou organização financeira."
  },
  {
    content: "170303 - Planejamento, coordenação, programação ou organização administrativa.",
    id: "170303 - Planejamento, coordenação, programação ou organização administrativa."
  },
  {
    content: "170401 - Recrutamento, agenciamento, seleção e colocação de mão-de-obra.",
    id: "170401 - Recrutamento, agenciamento, seleção e colocação de mão-de-obra."
  },
  {
    content: "170501 - Fornecimento de mão-de-obra, mesmo em caráter temporário, inclusive de empregados ou trabalhadores, avulsos ou temporários, contratados pelo prestador de serviço.",
    id: "170501 - Fornecimento de mão-de-obra, mesmo em caráter temporário, inclusive de empregados ou trabalhadores, avulsos ou temporários, contratados pelo prestador de serviço."
  },
  {
    content: "170601 - Propaganda e publicidade, inclusive promoção de vendas, planejamento de campanhas ou sistemas de publicidade, elaboração de desenhos, textos e demais materiais publicitários.",
    id: "170601 - Propaganda e publicidade, inclusive promoção de vendas, planejamento de campanhas ou sistemas de publicidade, elaboração de desenhos, textos e demais materiais publicitários."
  },
  {
    content: "170801 - Franquia (franchising).",
    id: "170801 - Franquia (franchising)."
  },
  {
    content: "170901 - Perícias, laudos, exames técnicos e análises técnicas.",
    id: "170901 - Perícias, laudos, exames técnicos e análises técnicas."
  },
  {
    content: "171001 - Planejamento, organização e administração de feiras, exposições, e congêneres.",
    id: "171001 - Planejamento, organização e administração de feiras, exposições, e congêneres."
  },
  {
    content: "171002 - Planejamento, organização e administração de congressos e congêneres.",
    id: "171002 - Planejamento, organização e administração de congressos e congêneres."
  },
  {
    content: "171101 - Organização de festas e recepções.",
    id: "171101 - Organização de festas e recepções."
  },
  {
    content: "171102 - Bufê (exceto o fornecimento de alimentação e bebidas, que fica sujeito ao ICMS).",
    id: "171102 - Bufê (exceto o fornecimento de alimentação e bebidas, que fica sujeito ao ICMS)."
  },
  {
    content: "171201 - Administração em geral, inclusive de bens e negócios de terceiros.",
    id: "171201 - Administração em geral, inclusive de bens e negócios de terceiros."
  },
  {
    content: "171301 - Leilão e congêneres.",
    id: "171301 - Leilão e congêneres."
  },
  {
    content: "171401 - Advocacia",
    id: "171401 - Advocacia"
  },
  {
    content: "171501 - Arbitragem de qualquer espécie, inclusive jurídica.",
    id: "171501 - Arbitragem de qualquer espécie, inclusive jurídica."
  },
  {
    content: "171601 - Auditoria.",
    id: "171601 - Auditoria."
  },
  {
    content: "171701 - Análise de Organização e Métodos.",
    id: "171701 - Análise de Organização e Métodos."
  },
  {
    content: "171801 - Atuária e cálculos técnicos de qualquer natureza.",
    id: "171801 - Atuária e cálculos técnicos de qualquer natureza."
  },
  {
    content: "171901 - Contabilidade, inclusive serviços técnicos e auxiliares.",
    id: "171901 - Contabilidade, inclusive serviços técnicos e auxiliares."
  },
  {
    content: "172001 - Consultoria e assessoria econômica ou financeira.",
    id: "172001 - Consultoria e assessoria econômica ou financeira."
  },
  {
    content: "172101 - Estatística.",
    id: "172101 - Estatística."
  },
  {
    content: "172201 - Cobrança em geral.",
    id: "172201 - Cobrança em geral."
  },
  {
    content: "172301 - Assessoria, análise, avaliação, atendimento, consulta, cadastro, seleção, gerenciamento de informações, administração de contas a receber ou a pagar e em geral, relacionados a operações de faturização (factoring).",
    id: "172301 - Assessoria, análise, avaliação, atendimento, consulta, cadastro, seleção, gerenciamento de informações, administração de contas a receber ou a pagar e em geral, relacionados a operações de faturização (factoring)."
  },
  {
    content: "172401 - Apresentação de palestras, conferências, seminários e congêneres.",
    id: "172401 - Apresentação de palestras, conferências, seminários e congêneres."
  },
  {
    content: "172501 - Inserção de textos, desenhos e outros materiais de propaganda e publicidade, em qualquer meio (exceto em livros, jornais, periódicos e nas modalidades de serviços de radiodifusão sonora e de sons e imagens de recepção livre e gratuita).",
    id: "172501 - Inserção de textos, desenhos e outros materiais de propaganda e publicidade, em qualquer meio (exceto em livros, jornais, periódicos e nas modalidades de serviços de radiodifusão sonora e de sons e imagens de recepção livre e gratuita)."
  },
  {
    content: "180101 - Serviços de regulação de sinistros vinculados a contratos de seguros e congêneres.",
    id: "180101 - Serviços de regulação de sinistros vinculados a contratos de seguros e congêneres."
  },
  {
    content: "180102 - Serviços de inspeção e avaliação de riscos para cobertura de contratos de seguros e congêneres.",
    id: "180102 - Serviços de inspeção e avaliação de riscos para cobertura de contratos de seguros e congêneres."
  },
  {
    content: "180103 - Serviços de prevenção e gerência de riscos seguráveis e congêneres.",
    id: "180103 - Serviços de prevenção e gerência de riscos seguráveis e congêneres."
  },
  {
    content: "190101 - Serviços de distribuição e venda de bilhetes e demais produtos de loteria, cartões, pules ou cupons de apostas, sorteios, prêmios, inclusive os decorrentes de títulos de capitalização e congêneres.",
    id: "190101 - Serviços de distribuição e venda de bilhetes e demais produtos de loteria, cartões, pules ou cupons de apostas, sorteios, prêmios, inclusive os decorrentes de títulos de capitalização e congêneres."
  },
  {
    content: "190102 - Serviços de distribuição e venda de bingos e congêneres.",
    id: "190102 - Serviços de distribuição e venda de bingos e congêneres."
  },
  {
    content: "200101 - Serviços portuários, ferroportuários, utilização de porto, movimentação de passageiros, reboque de embarcações, rebocador escoteiro, atracação, desatracação, serviços de praticagem, capatazia, armazenagem de qualquer natureza, serviços acessórios, movimentação de mercadorias, serviços de apoio marítimo, de movimentação ao largo, serviços de armadores, estiva, conferência, logística e congêneres. (prestado em terra)",
    id: "200101 - Serviços portuários, ferroportuários, utilização de porto, movimentação de passageiros, reboque de embarcações, rebocador escoteiro, atracação, desatracação, serviços de praticagem, capatazia, armazenagem de qualquer natureza, serviços acessórios, movimentação de mercadorias, serviços de apoio marítimo, de movimentação ao largo, serviços de armadores, estiva, conferência, logística e congêneres. (prestado em terra)"
  },
  {
    content: "200102 - Serviços portuários, ferroportuários, utilização de porto, movimentação de passageiros, reboque de embarcações, rebocador escoteiro, atracação, desatracação, serviços de praticagem, capatazia, armazenagem de qualquer natureza, serviços acessórios, movimentação de mercadorias, serviços de apoio marítimo, de movimentação ao largo, serviços de armadores, estiva, conferência, logística e congêneres. (prestado em águas marinhas)",
    id: "200102 - Serviços portuários, ferroportuários, utilização de porto, movimentação de passageiros, reboque de embarcações, rebocador escoteiro, atracação, desatracação, serviços de praticagem, capatazia, armazenagem de qualquer natureza, serviços acessórios, movimentação de mercadorias, serviços de apoio marítimo, de movimentação ao largo, serviços de armadores, estiva, conferência, logística e congêneres. (prestado em águas marinhas)"
  },
  {
    content: "200201 - Serviços aeroportuários, utilização de aeroporto, movimentação de passageiros, armazenagem de qualquer natureza, capatazia, movimentação de aeronaves, serviços de apoio aeroportuários, serviços acessórios, movimentação de mercadorias, logística e congêneres.",
    id: "200201 - Serviços aeroportuários, utilização de aeroporto, movimentação de passageiros, armazenagem de qualquer natureza, capatazia, movimentação de aeronaves, serviços de apoio aeroportuários, serviços acessórios, movimentação de mercadorias, logística e congêneres."
  },
  {
    content: "200301 - Serviços de terminais rodoviários, ferroviários, metroviários, movimentação de passageiros, mercadorias, inclusive suas operações, logística e congêneres.",
    id: "200301 - Serviços de terminais rodoviários, ferroviários, metroviários, movimentação de passageiros, mercadorias, inclusive suas operações, logística e congêneres."
  },
  {
    content: "210101 - Serviços de registros públicos, cartorários e notariais.",
    id: "210101 - Serviços de registros públicos, cartorários e notariais."
  },
  {
    content: "220101 - Serviços de exploração de rodovia mediante cobrança de preço ou pedágio dos usuários, envolvendo execução de serviços de conservação, maintenance, melhoramentos para adequação de capacidade e segurança de trânsito, operação, monitoração, assistência aos usuários e outros serviços definidos em contratos, atos de concessão ou de permissão ou em normas oficiais.",
    id: "220101 - Serviços de exploração de rodovia mediante cobrança de preço ou pedágio dos usuários, envolvendo execução de serviços de conservação, maintenance, melhoramentos para adequação de capacidade e segurança de trânsito, operação, monitoração, assistência aos usuários e outros serviços definidos em contratos, atos de concessão ou de permissão ou em normas oficiais."
  },
  {
    content: "230101 - Serviços de programação e comunicação visual e congêneres.",
    id: "230101 - Serviços de programação e comunicação visual e congêneres."
  },
  {
    content: "230102 - Serviços de desenho industrial e congêneres.",
    id: "230102 - Serviços de desenho industrial e congêneres."
  },
  {
    content: "240101 - Serviços de chaveiros, confecção de carimbos e congêneres.",
    id: "240101 - Serviços de chaveiros, confecção de carimbos e congêneres."
  },
  {
    content: "240102 - Serviços de placas, sinalização visual, banners, adesivos e congêneres.",
    id: "240102 - Serviços de placas, sinalização visual, banners, adesivos e congêneres."
  },
  {
    content: "250101 - Funerais, inclusive fornecimento de caixão, urna ou esquifes; aluguel de capela; transporte do corpo cadavérico; fornecimento de flores, coroas e outros paramentos; desembaraço de certidão de óbito; fornecimento de véu, essa e outros adornos; embalsamento, embelezamento, conservação ou restauração de cadáveres.",
    id: "250101 - Funerais, inclusive fornecimento de caixão, urna ou esquifes; aluguel de capela; transporte do corpo cadavérico; fornecimento de flores, coroas e outros paramentos; desembaraço de certidão de óbito; fornecimento de véu, essa e outros adornos; embalsamento, embelezamento, conservação ou restauração de cadáveres."
  },
  {
    content: "250201 - Translado intramunicipal de corpos e partes de corpos cadavéricos.",
    id: "250201 - Translado intramunicipal de corpos e partes de corpos cadavéricos."
  },
  {
    content: "250202 - Cremação de corpos e partes de corpos cadavéricos.",
    id: "250202 - Cremação de corpos e partes de corpos cadavéricos."
  },
  {
    content: "250301 - Planos ou convênio funerários.",
    id: "250301 - Planos ou convênio funerários."
  },
  {
    content: "250401 - Manutenção e conservação de jazigos e cemitérios.",
    id: "250401 - Manutenção e conservação de jazigos e cemitérios."
  },
  {
    content: "250501 - Cessão de uso de espaços em cemitérios para sepultamento.",
    id: "250501 - Cessão de uso de espaços em cemitérios para sepultamento."
  },
  {
    content: "260101 - Serviços de coleta, remessa ou entrega de correspondências, documentos, objetos, bens ou valores, inclusive pelos correios e suas agências franqueadas.",
    id: "260101 - Serviços de coleta, remessa ou entrega de correspondências, documentos, objetos, bens ou valores, inclusive pelos correios e suas agências franqueadas."
  },
  {
    content: "260102 - Serviços de courrier e congêneres.",
    id: "260102 - Serviços de courrier e congêneres."
  },
  {
    content: "270101 - Serviços de assistência social.",
    id: "270101 - Serviços de assistência social."
  },
  {
    content: "280101 - Serviços de avaliação de bens e serviços de qualquer natureza.",
    id: "280101 - Serviços de avaliação de bens e serviços de qualquer natureza."
  },
  {
    content: "290101 - Serviços de biblioteconomia.",
    id: "290101 - Serviços de biblioteconomia."
  },
  {
    content: "300101 - Serviços de biologia e biotecnologia.",
    id: "300101 - Serviços de biologia e biotecnologia."
  },
  {
    content: "300102 - Serviços de química.",
    id: "300102 - Serviços de química."
  },
  {
    content: "310101 - Serviços técnicos em edificações e congêneres.",
    id: "310101 - Serviços técnicos em edificações e congêneres."
  },
  {
    content: "310102 - Serviços técnicos em eletrônica, eletrotécnica e congêneres.",
    id: "310102 - Serviços técnicos em eletrônica, eletrotécnica e congêneres."
  },
  {
    content: "310103 - Serviços técnicos em mecânica e congêneres.",
    id: "310103 - Serviços técnicos em mecânica e congêneres."
  },
  {
    content: "310104 - Serviços técnicos em telecomunicações e congêneres.",
    id: "310104 - Serviços técnicos em telecomunicações e congêneres."
  },
  {
    content: "320101 - Serviços de desenhos técnicos.",
    id: "320101 - Serviços de desenhos técnicos."
  },
  {
    content: "330101 - Serviços de desembaraço aduaneiro, comissários, despachantes e congêneres.",
    id: "330101 - Serviços de desembaraço aduaneiro, comissários, despachantes e congêneres."
  },
  {
    content: "340101 - Serviços de investigações particulares, detetives e congêneres.",
    id: "340101 - Serviços de investigações particulares, detetives e congêneres."
  },
  {
    content: "350101 - Serviços de reportagem e jornalismo.",
    id: "350101 - Serviços de reportagem e jornalismo."
  },
  {
    content: "350102 - Serviços de assessoria de imprensa.",
    id: "350102 - Serviços de assessoria de imprensa."
  },
  {
    content: "350103 - Serviços de relações públicas.",
    id: "350103 - Serviços de relações públicas."
  },
  {
    content: "360101 - Serviços de meteorologia.",
    id: "360101 - Serviços de meteorologia."
  },
  {
    content: "370101 - Serviços de artistas, atletas, modelos e manequins.",
    id: "370101 - Serviços de artistas, atletas, modelos e manequins."
  },
  {
    content: "380101 - Serviços de museologia.",
    id: "380101 - Serviços de museologia."
  },
  {
    content: "390101 - Serviços de ourivesaria e lapidação (quando o material for fornecido pelo tomador do serviço).",
    id: "390101 - Serviços de ourivesaria e lapidação (quando o material for fornecido pelo tomador do serviço)."
  },
  {
    content: "400101 - Obras de arte sob encomenda.",
    id: "400101 - Obras de arte sob encomenda."
  },
  {
    content: "990101 - Serviços sem a incidência de ISSQN e ICMS",
    id: "990101 - Serviços sem a incidência de ISSQN e ICMS"
  }
]);

export default codigoTributacaoNacional;
